import { render, staticRenderFns } from "./Extratos.vue?vue&type=template&id=678c7e39&scoped=true&"
import script from "./Extratos.vue?vue&type=script&lang=js&"
export * from "./Extratos.vue?vue&type=script&lang=js&"
import style0 from "./Extratos.vue?vue&type=style&index=0&id=678c7e39&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678c7e39",
  null
  
)

export default component.exports